import type { DrmData, PlaybackContext } from '../../../data/playbackContext';
import type { KalturaPlaybackContext, KalturaPluginData } from '../../objects';

export function processPlaybackContext(playbackContext: KalturaPlaybackContext): PlaybackContext {
  return {
    sources: playbackContext.sources.map((source) => ({
      assetId: source.assetId,
      drmData: source.drm.map(processPlaybackSourceDrmData),
      format: source.format,
      id: source.id,
      type: source.type,
      url: source.url,
    })),
  };
}

function processDrmData(drmData: KalturaPluginData) {
  if (drmData.objectType === 'KalturaFairPlayPlaybackPluginData') {
    return {
      certificate: drmData.certificate,
    };
  }

  if (drmData.objectType === 'KalturaCustomDrmPlaybackPluginData') {
    return {
      data: drmData.data,
    };
  }
}

function processBaseDrmData(drmData: KalturaPluginData) {
  return {
    licenseUrl: drmData.licenseURL,
    scheme: drmData.scheme,
  };
}

function processPlaybackSourceDrmData(drmData: KalturaPluginData): DrmData {
  return {
    ...processBaseDrmData(drmData),
    ...processDrmData(drmData),
  };
}
